import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { crearAreaConfiguracion } from '../../../actions/configuracion';

const NuevaArea = ({ area, reestablecerArea }) => {

    const dispatch = useDispatch();

    const [show, setShow]   = useState(false);
    const [nombre, setNombre] = useState('');

    // Abrir/cerrar modal según la prop `area`
    useEffect(() => {
        if (area) {
            setNombre('');
            setShow(true);
        } else {
            setShow(false);
        }
    }, [area]);

    const handleClose = () => {
        setShow(false);
        reestablecerArea(null); // deja el state como en categorías
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nombre.trim()) {
            return;
        }

        const resp = await dispatch(crearAreaConfiguracion({ nombre: nombre.trim() }));

        if (resp && resp.success) {
            handleClose(); // se cierra y el reducer ya agregó el registro a la tabla
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h5 className="modal-title">Agregar área</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                        aria-label="Close"
                    ></button>
                </div>

                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label">Nombre</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre del área"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleClose}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default NuevaArea;
